module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Mail Page"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Mail Page")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "compose"
  }, [_c('ul', [_c('li', [_c('i', {
    staticClass: "ti-pencil-alt"
  }), _c('span', [_vm._v("Compose")])]), _c('li', [_c('i', {
    staticClass: "ti-import"
  }), _vm._v("Inbox "), _c('span', [_vm._v("(2,343)")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "ti-new-window"
  }), _vm._v("Sent Mail")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "ti-pin-alt"
  }), _vm._v("Important")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "ti-zip"
  }), _vm._v("Draft")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "ti-trash"
  }), _vm._v("Trash")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "text-orange"
  }, [_c('i', {
    staticClass: "ti-control-record"
  }), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Family")])]), _vm._v(" "), _c('li', {
    staticClass: "text-red"
  }, [_c('i', {
    staticClass: "ti-control-record"
  }), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Friend")])]), _vm._v(" "), _c('li', {
    staticClass: "text-blue"
  }, [_c('i', {
    staticClass: "ti-control-record"
  }), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Office")])]), _vm._v(" "), _c('li', {
    staticClass: "text-aqua"
  }, [_c('i', {
    staticClass: "ti-control-record"
  }), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Social")])]), _vm._v(" "), _c('li', {
    staticClass: "text-dark-blue"
  }, [_c('i', {
    staticClass: "ti-control-record"
  }), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Unknown")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "inbox-nest"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "inbox-header"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "ti-reload"
  }), _vm._v(" Refresh ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "ti-export"
  }), _vm._v(" Reply ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "ti-share"
  }), _vm._v(" Reply All ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "ti-trash"
  }), _vm._v(" Trash ")]), _vm._v(" "), _c('li', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1-50 of 10,976")])])])])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "img-circle star",
    attrs: {
      "alt": "",
      "src": "http://api.randomuser.me/portraits/thumb/men/22.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("David L. Moore")]), _c('i', {
    staticClass: "icon-attachment"
  }), _c('i', {
    staticClass: "text-orange fontello-record"
  }), _c('small', [_vm._v("Today, 09:21 PM")]), _vm._v(" "), _c('h5', [_vm._v("Will You Be Our Valentine?")]), _vm._v(" "), _c('p', [_vm._v("Hi, John i just want to know about my email that i,ve sending yesterday. Dou you read it? ... ")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "img-circle star",
    attrs: {
      "alt": "",
      "src": "http://api.randomuser.me/portraits/thumb/women/23.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Helen D. Murray")]), _c('i', {
    staticClass: "text-blue fontello-record"
  }), _c('small', [_vm._v("20 Minute ago")]), _vm._v(" "), _c('h5', [_vm._v("World Recod")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam erat nunc, vestibulum eu venenatis ut, feugiat sit amet elit. Donec convallis ornare odio. Donec ac est eget lacus molestie imperdiet vitae ac nunc. Suspendisse odio justo ... ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "star bg-red",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa  fa-google-plus"
  })]), _vm._v(" "), _c('b', [_vm._v("Google+ (DesignByHuman)")]), _c('i', {
    staticClass: "text-aqua fontello-record"
  }), _c('small', [_vm._v("1 Hour Ago")]), _vm._v(" "), _c('h5', [_vm._v("Berbagi pos - \"This #DOTD by Viviana González makes us ..")]), _vm._v(" "), _c('p', [_vm._v("Donec sed mi sem. Maecenas posuere justo dapibus fermentum porttitor. Phasellus ornare lectus a neque molestie sodales. Pellentesque consectetur sed nisl vitae tempor. Duis et odio ut ligula accumsan interdum. ... ")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "img-circle star",
    attrs: {
      "alt": "",
      "src": "http://api.randomuser.me/portraits/thumb/women/25.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Deanna G. Rumph")]), _c('i', {
    staticClass: " icon-attachment"
  }), _c('i', {
    staticClass: "text-red fontello-record"
  }), _c('small', [_vm._v("Yesterday, 09:21 PM")]), _vm._v(" "), _c('h5', [_vm._v("A new rating has been received for Aurelo Resume")]), _vm._v(" "), _c('p', [_vm._v("Etiam cursus feugiat nibh eu efficitur. Praesent lobortis imperdiet neque in tempor. Praesent eu molestie urna, nec dapibus mi. Etiam blandit convallis ligula, sodales sodales nulla scelerisque ac ... ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "star bg-blue",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa  fa-twitter"
  })]), _vm._v(" "), _c('b', [_vm._v("Twitter (@Themesmile)")]), _c('i', {
    staticClass: "text-aqua fontello-record"
  }), _c('small', [_vm._v("11 November")]), _vm._v(" "), _c('h5', [_vm._v("Latest tweet from Beyonce")]), _vm._v(" "), _c('p', [_vm._v("Suspendisse cursus purus eget magna molestie, a finibus odio malesuada. Maecenas sodales quam a egestas maximus. Donec ultricies nibh eros, non sagittis odio convallis posuere. Nam dolor velit, tincidunt in libero vel ... ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "star bg-dark-blue",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa  fa-facebook"
  })]), _vm._v(" "), _c('b', [_vm._v("Facebook ( Gifta Kamilia Putri)")]), _c('i', {
    staticClass: "text-aqua fontello-record"
  }), _c('small', [_vm._v("10 November")]), _vm._v(" "), _c('h5', [_vm._v("People that may you know!")]), _vm._v(" "), _c('p', [_vm._v("Fusce eros lectus, hendrerit sit amet nibh et, accumsan sollicitudin urna. Maecenas ac ex id velit imperdiet tincidunt consectetur vel neque. Morbi ornare nibh sapien, sit amet tempus risus dapibus vitae. Donec volutpat, libero sit amet faucibus placerat ... ")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "img-circle star",
    attrs: {
      "alt": "",
      "src": "http://api.randomuser.me/portraits/thumb/men/40.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("James B. Miller")]), _c('i', {
    staticClass: "icon-attachment"
  }), _c('i', {
    staticClass: "text-orange fontello-record"
  }), _c('small', [_vm._v("10 November")]), _vm._v(" "), _c('h5', [_vm._v("Will You Be Our Valentine?")]), _vm._v(" "), _c('p', [_vm._v("Hi, John i just want to know about my email that i,ve sending yesterday. Dou you read it? ... ")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "img-circle star",
    attrs: {
      "alt": "",
      "src": "http://api.randomuser.me/portraits/thumb/men/41.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("John P. McCarthy")]), _c('i', {
    staticClass: "text-blue fontello-record"
  }), _c('small', [_vm._v("09 November")]), _vm._v(" "), _c('h5', [_vm._v("World Recod")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam erat nunc, vestibulum eu venenatis ut, feugiat sit amet elit. Donec convallis ornare odio. Donec ac est eget lacus molestie imperdiet vitae ac nunc. Suspendisse odio justo ... ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "star bg-yellow",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "fa  fa-dribbble"
  })]), _vm._v(" "), _c('b', [_vm._v("Dribbble (Matt Wulleang)")]), _c('i', {
    staticClass: "text-aqua fontello-record"
  }), _c('small', [_vm._v("09 November")]), _vm._v(" "), _c('h5', [_vm._v("Berbagi pos - \"This #DOTD by Viviana González makes us ..")]), _vm._v(" "), _c('p', [_vm._v("Donec sed mi sem. Maecenas posuere justo dapibus fermentum porttitor. Phasellus ornare lectus a neque molestie sodales. Pellentesque consectetur sed nisl vitae tempor. Duis et odio ut ligula accumsan interdum. ... ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "inbox-header"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "ti-reload"
  }), _vm._v(" Refresh ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "ti-export"
  }), _vm._v(" Reply ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "ti-share"
  }), _vm._v(" Reply All ")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "ti-trash"
  }), _vm._v(" Trash ")]), _vm._v(" "), _c('li', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1-50 of 10,976")])])])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bb0b2f4a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Mail.vue
// module id = 1434
// module chunks = 2